import React, { Fragment, useEffect, useState } from 'react';
import { Icon } from 'antd';
import { AuthCredential } from 'swuif';
import { authStorage } from '@/config';
import * as saAuth from '@/clients/auth/samsungAccount';
import { KC_STATE, ROLE_LIST_NAME } from '@/clients/keycloak/type';
import ReactDOM from 'react-dom';
import App from '@/components/App';
import * as utils from '@/components/utils';

const statusEnum = ['register', 'inactive', 'pending', 'reject', 'approve'];

const LoginCallback = () => {
  const [textActive, setTextActive] = useState('Loading.');
  const [dateNum, setDateNum] = useState(new Date().getTime());
  const [tempNum, setTempNum] = useState(new Date().getTime());

  const errorStatePage = (states: typeof statusEnum[number], saUser: any) => {
    utils.setStorage('loginState', states);
    utils.setStorage('userDetails', JSON.stringify(saUser));
    saAuth.logOutUser();
  };

  const getRole = (userData: any) => {
    const userRole =
      (userData && userData.realm_access && userData.realm_access.roles) || [];
    let curRole = '';
    Object.keys(ROLE_LIST_NAME).forEach(role => {
      if (userRole.indexOf(role) > -1) {
        curRole = role;
        return;
      }
    });
    return curRole;
  };

  const generateUserData = async (userData: any, isRegister: boolean) => {
    if (userData['state'] === KC_STATE.DISABLED) {
      errorStatePage('inactive', userData);
    } else if (userData['state'] === KC_STATE.DELETED) {
      if (isRegister) utils.setStorage('registerState', 'register');
      errorStatePage('register', userData);
    } else if (userData['state'] === KC_STATE.REJECTED) {
      errorStatePage('reject', userData);
    } else if (userData['state'] === KC_STATE.PENDING) {
      errorStatePage('pending', userData);
    } else if (userData['state'] === KC_STATE.APPROVED) {
      errorStatePage('approve', userData);
    } else if (userData['state'] === KC_STATE.ACTIVE) {
      if (!isRegister) {
        const role = getRole(userData);
        const userCredential: AuthCredential = {
          key: userData.preferred_username || '',
          user: {
            role: ROLE_LIST_NAME[role],
            userId: userData.sub || '',
            fullName: userData.preferred_username || '',
            // avatar: userData.picture,
            keycloakRole: role,
            mnId: userData.mnid || [],
            email: userData.email || '',
          },
        };
        await authStorage.store(userCredential, true);
      } else {
        saAuth.clearLocalStorage();
        utils.setStorage('registerState', 'login');
      }
      ReactDOM.render(<App />, document.getElementById('root'));
    } else if (isRegister) {
      utils.setStorage('registerState', 'register');
      utils.setStorage('userDetails', JSON.stringify(userData));
      ReactDOM.render(<App />, document.getElementById('root'));
    } else {
      errorStatePage('register', userData);
    }
  };

  useEffect(() => {
    if (utils.getStorage('US_TokenParsed')) {
      const userData = JSON.parse(utils.getStorage('US_TokenParsed'));
      const isRegister = utils.getStorage('fromRegister');
      utils.removeStorage('US_TokenParsed');
      utils.removeStorage('fromRegister');
      generateUserData(userData, !!isRegister);
    } else window.location.replace(window.location.origin);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const newNum = new Date().getTime();
    const diff = newNum - dateNum;
    if (diff >= 200) {
      if (textActive.length === 8) {
        setTextActive('Loading..');
      } else if (textActive.length === 9) {
        setTextActive('Loading...');
      } else {
        setTextActive('Loading.');
      }
      setDateNum(newNum);
    }
    setTimeout(() => {
      const newNum = new Date().getTime();
      setTempNum(newNum);
    }, 400);
    // eslint-disable-next-line
  }, [tempNum]);

  return (
    <Fragment>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '200px' }}>
          <Icon
            style={{ fontSize: '28px', marginRight: '10px' }}
            type="loading-3-quarters"
            spin
          />
          <span
            style={{ fontFamily: 'Samsung Sharp Sans Bold', fontSize: '28px' }}
          >
            {textActive}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginCallback;
